import React from 'react';

export const DangerIcon = ({nameOfClass}) => (
    <svg className={nameOfClass} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12.0002" cy="11.9997" r="9.22143" stroke="#FF3B30" strokeWidth="1.5"/>
        <path d="M12 7.22656V13.6311" stroke="#FF3B30" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M12 16.0068L12 16.3632" stroke="#FF3B30" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
);
